export type CategoryOrderBy = 'CREATION_DATE' | 'CATEGORY_TITLE';
export type CategoryOrderDir = 'ASC' | 'DESC';

export interface CategoryFilters {
  categoryTitle: string;
  createdOnFrom: string | null;
  createdOnTo: string | null;
  lastUpdatedOnFrom: string | null;
  lastUpdatedOnTo: string | null;
  orderBy: CategoryOrderBy;
  orderDir: CategoryOrderDir;
}

export const DEFAULT_CATEGORY_FILTERS: CategoryFilters = {
  categoryTitle: '',
  createdOnFrom: null,
  createdOnTo: null,
  lastUpdatedOnFrom: null,
  lastUpdatedOnTo: null,
  orderBy: 'CREATION_DATE',
  orderDir: 'ASC',
};
